import React, { useState } from "react";
import { useNavigate } from "react-router";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { InputOtp } from "primereact/inputotp";
import { Link, useLocation } from "react-router-dom";
import api from "../../../services/api";
import { AxiosError } from "axios";
import { showBasicAlert } from "../../../core/common/useAlert";
import {
  ROLE_SUPER_ADMIN,
  ROLE_SUPER_ADMIN_CHAR,
  ROLE_ADMIN,
  ROLE_ADMIN_CHAR,
  ROLE_EMPLOYEE,
  ROLE_EMPLOYEE_CHAR,
} from "../../../environment";

import { useDispatch } from "react-redux";
import { setUser } from "../../../core/data/redux/userSlice";

const TwoStepVerification2 = () => {
  const location = useLocation();
  const { state } = location;
  const dispatch = useDispatch();

  const routes = all_routes;
  const navigation = useNavigate();

  const navigationPath = (userDetails: any) => {
    const userData = { userDetails };
    dispatch(setUser(userData));
    if (
      userDetails.role === ROLE_SUPER_ADMIN &&
      userDetails.role_char.toLowerCase() ===
        ROLE_SUPER_ADMIN_CHAR.toLowerCase()
    ) {
      navigation(routes.superAdminDashboard);
    } else if (
      userDetails.role === ROLE_ADMIN &&
      userDetails.role_char.toLowerCase() === ROLE_ADMIN_CHAR.toLowerCase()
    ) {
      navigation(routes.adminDashboard);
    } else {
      navigation(routes.adminDashboard);
    }
  };

  const [token, setTokens] = useState<any>();

  const handleSubmit = async (event: React.FormEvent) => {
    try {
      var email = state.email;
      var otp = token;
      event.preventDefault();
      const response = await api.post("userService/verify_login", {
        email,
        otp,
      });
      if (response) {
        localStorage.setItem("token", response.data.data.jwt_token);
        localStorage.setItem("signature", response.data.data.userDetails.token);
        localStorage.removeItem("selectedAssetCompany"); //removing assetCompany from local storage
        localStorage.removeItem("selectedERSCompany"); //removing assetCompany from local storage
        navigationPath(response.data.data.userDetails);
      }
    } catch (err) {
      const error = err as AxiosError; // Explicitly typecasting
      if (error.response) {
        const message = (
          error.response.data as {
            message: Array<{ msg: string; param: string }>;
          }
        ).message;
        if (message && message.length > 0) {
          for (let i = 0; i < message.length; i++) {
            var msg =
              message[i].param !== undefined
                ? message[i].param.toUpperCase() + " is "
                : "";
            showBasicAlert(msg + message[i].msg);
          }
        }
      }
    }
  };

  return (
    <>
      <style>
        {`
          .rbt-header-sticky {
              font-size: 15px;
              line-height: 1.5;
              font-family: var(--font-primary);
              background: url('assets/images/LoginBg.png') no-repeat center center fixed;
              background-size: cover;
              width: 100%;
              margin:0px;
              font-weight: 400;
              scroll-behavior: auto;
              position: relative;
              overflow-x: hidden;
              scrollbar-width: thin;
            }
            .p-inputotp-input {
              border: 2px solid #1D71E3 !important;
            }
      `}
      </style>
      <div className="rbt-header-sticky">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            <div className="col-lg-5">
              <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
                <div>
                  <ImageWithBasePath
                    src="assets/img/bg/authentication-bg-08.svg"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 ">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div className="col-md-7 mx-auto p-4">
                  <form>
                    <div>
                      <div className=" mx-auto mb-5 text-center">
                        <ImageWithBasePath
                          src="assets/images/logo.svg"
                          className="img-fluid"
                          alt="Logo"
                        />
                      </div>
                      <div className="">
                        <div className="text-center mb-3">
                          <h2 className="mb-2">2 Step Verification</h2>
                          <p className="mb-0" style={{ color: "black" }}>
                            Please enter the OTP received to confirm your
                            account ownership. A code has been send to{" "}
                            {state.email}
                          </p>
                        </div>
                        <div className="text-center otp-input">
                          <div className="d-flex align-items-center justify-content-center mb-3 otp-container">
                            <InputOtp
                              value={token}
                              onChange={(e) => setTokens(e.value)}
                              integerOnly
                              className="custom-otp-input"
                              pt={{
                                input: {
                                  style: {
                                    border: "2px solid #007bff",
                                    borderRadius: "6px",
                                  },
                                },
                              }}
                            />
                          </div>
                          <div>
                            <div className="mb-3 d-flex justify-content-center">
                              <p className="text-gray-9">
                                Didn't get the OTP?{" "}
                                <span
                                  className="text-primary"
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    showBasicAlert(
                                      "Enter By default password 4321"
                                    );
                                  }}
                                >
                                  Resend OTP
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            onClick={handleSubmit}
                            className="btn w-100"
                            style={{
                              backgroundColor: "#1D71E3",
                              color: "#FFFFFF",
                            }}
                          >
                            Verify &amp; Proceed
                          </button>
                        </div>
                      </div>
                      <div className="mt-5 text-center">
                        <p className="mb-0 text-gray-9">
                          Copyright © 2025 - ZYVO
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoStepVerification2;
